export class StagingBucket {
  public id: string;
  public reference_id: string;
  public name: string;
  public columns: {key: string, description: string}[] = [];
  public is_active: boolean | undefined;
  public h_toggle_active: string | undefined;
  public displayErrorMessage: boolean | undefined;
}
